var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.091 3.90625C15.0759 3.90625 13.4121 5.43847 13.2031 7.39898C14.6656 8.30628 15.6418 9.92632 15.6418 11.7703V14.4063C15.6418 15.3679 15.2084 16.2518 14.4988 16.8407V20.3809C14.4988 20.7206 14.7742 20.9961 15.114 20.9961H19.0679C19.4077 20.9961 19.6831 20.7206 19.6831 20.3809V14.2622C20.4485 14.0046 21.0011 13.2803 21.0011 12.4293V7.81639C21.0011 5.66037 19.247 3.90625 17.091 3.90625Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0879 3.90523C18.1659 3.90523 19.043 3.02819 19.043 1.95013C18.9447 -0.640004 15.2307 -0.639265 15.1328 1.95017C15.1328 3.02819 16.0098 3.90523 17.0879 3.90523Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.456 5.90431C12.456 4.82626 11.579 3.94922 10.5009 3.94922C7.91079 4.04749 7.91149 7.7615 10.501 7.8594C11.5789 7.8594 12.456 6.98236 12.456 5.90431Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5011 7.85938C8.48605 7.85938 6.8223 9.3916 6.61328 11.3521C8.07578 12.2594 9.05191 13.8794 9.05191 15.7235V16.3824C9.05191 17.344 8.61858 18.2279 7.90892 18.8168V20.3801C7.90892 20.7199 8.18438 20.9953 8.52416 20.9953H12.4781C12.8178 20.9953 13.0933 20.7199 13.0933 20.3801V16.2383C13.8586 15.9808 14.4113 15.2565 14.4113 14.4055V11.7695C14.4113 9.61345 12.6572 7.85938 10.5011 7.85938Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91014 11.8125C1.74673 11.8125 0 13.5636 0 15.7226V16.3816C0 17.2326 0.552644 17.9569 1.31796 18.2145V20.3793C1.31796 20.719 1.59342 20.9945 1.93319 20.9945H5.8871C6.22687 20.9945 6.50233 20.719 6.50233 20.3793V18.2145C7.26764 17.9569 7.82029 17.2326 7.82029 16.3816V15.7226C7.82033 13.5596 6.0697 11.8125 3.91014 11.8125Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90822 11.8115C4.98623 11.8115 5.86331 10.9344 5.86331 9.85638C5.76504 7.26625 2.05103 7.26698 1.95312 9.85642C1.95317 10.9344 2.8302 11.8115 3.90822 11.8115Z",
    fill: "#0098C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeGroup);
export default __webpack_public_path__ + "static/media/ageGroup.5adc2d1950ba1d824ebfe8d3a6a2aefb.svg";
export { ForwardRef as ReactComponent };